import { LocationModel } from './location.model';
import { Route } from './alarmroutes.model';
import { ReceiverTeam } from './receiver-team';

export class StaffModel {
  id: string;
  fullName: string;
  firstName: string;
  familyName: string;
  username: string;
  emaOnline: string;
  alarmRoutes: Route[];
  teams: ReceiverTeam[];
  locationId: string;
  language: string;
  gsmNumber: string;
  email: string;
  usingLevel: number;
  roleType: string;
  location: LocationModel;
  passwordChanged: string;
  locked: boolean;
  identityUsername: string;
  temporaryCodeAccess: boolean;
  temporaryCodeAccessModified: boolean;
  fallbackInRoutes: FallbackInRoutes[];
  lastLoginTime?: string;
  lastLoginService?: string;
  /** Signs in with a login identity: GET api/Personnel/Names gives this instead of identityUsername */
  hasIdentity?: boolean;
}


export class IdentityUser {
  username: string;
  firstname: string;
  familyName: string;
  email: string;
  staffId?: string;
}

export interface FallbackInRoutes {
  id: string;
  name: string;
}

export interface CreateLandingPageUserRequest {
  firstName: string;
  familyName: string;
  email: string;
  username: string;
  password: string;
  convertToFederated?: boolean;
}

export interface CreateLandingPageUserResponse {
  staffId: string;
  identityId: string;
  username: string;
}